import { defineStore } from 'pinia'
import { ref } from 'vue'
import { setStorage, getStorage, removeStorage } from '@/utils/storage'
import storage from '@/local/storage'
import { getUserInfo, postTgLogin } from '@/service'
import { refreshBalance } from '@/service/wallet'
import { showModal } from '@/utils'
import i18n from '@/locale'

const { t } = i18n.global

export const useUserStore = defineStore(
  'user',
  () => {
    const token = ref<any>({})
    const userInfo = ref<IUserInfo>()

    // 用户登陆时间
    const userLoginTime = ref<number>(null)

    // 设置用户登陆时间
    const setUserLoginTime = () => {
      userLoginTime.value = Date.now()
    }

    const setToken = (val: string) => {
      setStorage(storage.TOKEN, val)
      token.value = val
    }

    const setUserInfo = (val: IUserInfo) => {
      userInfo.value = val
      setStorage(storage.USER_INFO, val)
    }

    const clearUserInfo = () => {
      userInfo.value = undefined
      checkinPopup.value = false
      firstCheckin.value = false
      token.value = {}
      removeStorage(storage.USER_INFO)
      removeStorage(storage.TOKEN)
    }
    const isLogined = computed(() => !!token.value.token)

    const firstCheckin = ref(false)
    const checkinPopup = ref(false)
    const checkinConfig = ref({})
    const userCheckinInfo = ref({})

    const getUserInfoData = async () => {
      const res = await getUserInfo()
      if (res.code === 0) {
        setUserInfo(res.data)
      }
    }

    const updateUserInfo = async () => {
      if (!isLogined.value) return
      const res = await getUserInfo()
      // console.log(res)
      if (res.code === 0) {
        setUserInfo(res.data)
      }
    }

    // 回收余额
    const refreshUserGameBalance = async () => {
      const result = await showModal(t('wallet.refreshBalance'), {
        showCancel: true,
      })
      if (result.confirm) {
        const res = await refreshBalance()
        if (res.code === 0) {
          uni.showToast({
            title: t('wallet.refreshBalanceSuccess'),
            icon: 'success',
          })
          updateUserInfo()
        } else {
          uni.showToast({
            title: res.msg,
            icon: 'none',
          })
        }
      }
    }

    // tg登录
    const tgLogin = async () => {
      const tg = getStorage('tg')
      const res = await postTgLogin({
        tgId: tg.initDataUnsafe.user.id,
      })
      if (res.code === 0) {
        setToken(res.data.token)
        updateUserInfo()
      }
      return res
    }

    return {
      userLoginTime,
      setUserLoginTime,
      userInfo,
      setUserInfo,
      clearUserInfo,
      isLogined,
      token,
      setToken,
      updateUserInfo,
      getUserInfoData,
      checkinPopup,
      checkinConfig,
      userCheckinInfo,
      firstCheckin,
      refreshUserGameBalance,
      tgLogin,
    }
  },
  {
    persist: true,
  },
)
